<template>
  <div class="div">
    <div class="form border">
      <div class="row p-3">
        <div class="col-md-12">
          <div>
            <div class="page-heading mb-3">Select Report Settings</div>
          </div>

          <div class="mt-3 border p-2">
            <label class="form-label">Select Date Range:</label>
            <div class="d-flex">
              <div class="col-md-4">
                <label class="form-label" for="startdate"> Start Date: </label>

                <a-date-picker
                  class="form-control"
                  format="MM/DD/YYYY"
                  v-model="sDate"
                  name="startdate"
                  @change="startDate"
                  :allowClear="false"
                />
              </div>
              <div class="ms-4 col-md-4">
                <label class="form-label" for="enddate"> End Date: </label>
                <a-date-picker
                  class="form-control"
                  format="MM/DD/YYYY"
                  name="enddate"
                  v-model="eDate"
                  @change="endDate"
                  :allowClear="false"
                />
              </div>
            </div>
          </div>

          <div class="mt-3 border p-2">
            <label class="form-label">Select a client:</label>
            <div class="d-flex">
              <div class="form-check col-md-4">
                <input
                  class="form-check-input"
                  type="radio"
                  id="is_all_clients_selected"
                  v-model="form.is_all_clients_selected"
                  :value="true"
                  @input="allClients"
                />
                <label class="form-check-label" for="is_all_clients_selected">
                  All Clients
                </label>
              </div>

              <div class="form-check ms-4 col-md-4">
                <input
                  class="form-check-input"
                  type="radio"
                  id="is_all_clients_selected"
                  v-model="form.is_all_clients_selected"
                  :value="false"
                />
                <label class="form-check-label" for="is_all_clients_selected">
                  Selected Clients
                </label>
                <b-select
                  class="form-select form-select-sm mt-2"
                  aria-label=".form-select-sm example"
                  multiple="true"
                  size="5"
                  v-model="form.client_ids"
                  @change="clientSelected"
                >
                  <option
                    v-for="client in this.authorizedClients"
                    :key="client.index"
                    :value="client.clientId"
                  >
                    {{ client.clientName }}
                  </option>
                </b-select>
              </div>
            </div>
          </div>

          <div class="mt-3 border p-2">
            <label class="form-label">Select Programs and Contest:</label>
            <div class="d-flex">
              <div class="form-check col-md-4">
                <input
                  class="form-check-input"
                  type="radio"
                  name="is_all_programs_selected"
                  id=""
                  v-model="form.is_all_programs_selected"
                  :value="true"
                  @input="allPrograms"
                />
                <label class="form-check-label" for="is_all_programs_selected">
                  All Programs & Contests
                </label>
              </div>

              <div class="form-check ms-4 col-md-4">
                <input
                  class="form-check-input"
                  type="radio"
                  name="is_all_programs_selected"
                  id=""
                  v-model="form.is_all_programs_selected"
                  :value="false"
                />
                <label class="form-check-label" for="is_all_programs_selected">
                  Selected Programs & Contests
                </label>

                <div v-if="AllClientsProgram && AllClientsProgram.length > 0">
                  <!-- {{ AllClientsProgram }}
                  {{ AllClientsProgram[0].authorized_clients_programs }} -->
                  <b-select
                    class="form-select form-select-sm mt-2"
                    aria-label=".form-select-sm example"
                    multiple="true"
                    size="5"
                    v-model="form.program_ids"
                    @change="programSelected"
                  >
                    <option
                      v-for="program in AllClientsProgram[0]
                        .authorized_clients_programs"
                      :key="program.index"
                      :value="program.program_id"
                    >
                      {{ program.program_name }}
                    </option>
                  </b-select>
                </div>
                <div v-else>
                  <b-select
                    class="form-select form-select-sm mt-2"
                    aria-label=".form-select-sm example"
                    multiple="true"
                    size="5"
                  >
                  </b-select>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-3 border p-2">
            <label class="form-label">Select User Code:</label>
            <div class="d-flex">
              <div class="form-check col-md-4">
                <input
                  class="form-check-input"
                  type="radio"
                  name="is_all_user_code_selected"
                  id=""
                  v-model="form.is_all_user_code_selected"
                  :value="true"
                  @input="allUserCode"
                />
                <label class="form-check-label" for="is_all_user_code_selected">
                  All User Codes
                </label>
              </div>

              <div class="form-check ms-4 col-md-4">
                <input
                  class="form-check-input"
                  type="radio"
                  name="is_all_user_code_selected"
                  id=""
                  v-model="form.is_all_user_code_selected"
                  :value="false"
                />
                <label class="form-check-label" for="is_all_user_code_selected">
                  Selected User Codes
                </label>
                <b-select
                  class="form-select form-select-sm mt-2"
                  aria-label=".form-select-sm example"
                  multiple="true"
                  size="5"
                  v-model="form.user_codes"
                  @change="userCodeSelected"
                >
                  <option
                    v-for="code in userCodes"
                    :value="code"
                    :key="code.index"
                  >
                    {{ code }}
                  </option>
                </b-select>
              </div>
            </div>
          </div>

          <div class="mt-3 border p-2">
            <label class="form-label"
              >What transaction types do you wish to include?
            </label>
            <div class="">
              <div class="row">
                <div class="col-md-5">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      checked
                      name="is_all_transactions_selected"
                      v-model="form.is_all_transactions_selected"
                      @input="allTransactions"
                    />

                    <label
                      class="form-check-label"
                      for="is_all_transactions_selected"
                    >
                      All Transaction Types
                    </label>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      name="show_my_transaction"
                      v-model="form.show_my_transaction"
                    />
                    <label class="form-check-label" for="show_my_transaction">
                      My Transactions Only
                    </label>
                  </div>
                </div>

                <div class="mt-2 pl-3" style="width: 100%;">
                  <div class="row">
                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="ORDER"
                        v-model="form.transaction_types"
                        id="order"
                      />
                      <span class="form-check-label" for="order"> Orders </span>
                    </div>

                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="CREDIT"
                        v-model="form.transaction_types"
                        id="credit"
                      />
                      <span class="form-check-label" for="credit">
                        Credits
                      </span>
                    </div>

                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="POINTS ADDED"
                        v-model="form.transaction_types"
                        id="points_added"
                      />
                      <span class="form-check-label" for="points_added">
                        Added Points
                      </span>
                    </div>

                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="API POINTS ADDED"
                        v-model="form.transaction_types"
                        id="api_points_added"
                      />
                      <span class="form-check-label" for="api_points_added">
                        API Added Points
                      </span>
                    </div>

                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="POINTS SUBTRACTED"
                        v-model="form.transaction_types"
                        id="points_subtracted"
                      />
                      <span class="form-check-label" for="points_subtracted">
                        Subtracted Points
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="USER ADDED"
                        v-model="form.transaction_types"
                        id="user_added"
                      />
                      <span class="form-check-label" for="user_added">
                        Added Users
                      </span>
                    </div>

                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="USER LOCKED"
                        v-model="form.transaction_types"
                        id="user_locked"
                      />
                      <span class="form-check-label" for="user_locked">
                        Locked Users
                      </span>
                    </div>

                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="USER UNLOCKED"
                        v-model="form.transaction_types"
                        id="user_unlocked"
                      />
                      <span class="form-check-label" for="user_unlocked">
                        Unlocked Users
                      </span>
                    </div>

                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="ORDER TAX"
                        v-model="form.transaction_types"
                        id="order_tax"
                      />
                      <span class="form-check-label" for="order_tax">
                        Order Tax
                      </span>
                    </div>

                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="CREDIT TAX"
                        v-model="form.transaction_types"
                        id="credit_tax"
                      />
                      <span class="form-check-label" for="credit_tax">
                        Credit Tax
                      </span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="CLIENT ADDED"
                        v-model="form.transaction_types"
                        id="client_added"
                      />
                      <span class="form-check-label" for="client_added">
                        Added Clients
                      </span>
                    </div>

                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="CLIENT DELETED"
                        v-model="form.transaction_types"
                        id="client_deleted"
                      />
                      <span class="form-check-label" for="client_deleted">
                        Deleted Clients
                      </span>
                    </div>

                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="SUPPLIER ADDED"
                        v-model="form.transaction_types"
                        id="supplier_added"
                      />
                      <span class="form-check-label" for="supplier_added">
                        Added Suppliers
                      </span>
                    </div>

                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="SUPPLIER DELETED"
                        v-model="form.transaction_types"
                        id="supplier_deleted"
                      />
                      <span class="form-check-label" for="supplier_deleted">
                        Deleted Suppliers
                      </span>
                    </div>

                    <div class="form-check m-1 col-md-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        @input="transactionSelected"
                        value="REBATE"
                        v-model="form.transaction_types"
                        id="rebate"
                      />
                      <span class="form-check-label" for="rebate">
                        Rebates
                      </span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-check m-1 col-md-2">
                      <input
                          class="form-check-input"
                          type="checkbox"
                          @input="transactionSelected"
                          value="NO ORDERS"
                          v-model="form.transaction_types"
                          id="no_order"
                          />
                      <span class="form-check-label" for="no_order">
                      No Orders
                      </span>
                    </div>
                    <div class="form-check m-1 col-md-2">
                      <input
                          class="form-check-input"
                          type="checkbox"
                          @input="transactionSelected"
                          value="SALES TAX"
                          v-model="form.transaction_types"
                          id="no_order"
                          />
                      <span class="form-check-label" for="no_order">
                      Sales Tax
                      </span>
                    </div>
                    <div class="form-check m-1 col-md-2">
                      <input
                          class="form-check-input"
                          type="checkbox"
                          @input="transactionSelected"
                          value="CREDIT SALES TAX"
                          v-model="form.transaction_types"
                          id="no_order" 
                          />
                      <span class="form-check-label" for="no_order">
                      Credit Sales Tax
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-3 border p-2">
            <label class="form-label">Show Totals or Records:</label>
            <div class="d-flex">
              <div class="form-check col-md-2">
                <input
                  class="form-check-input"
                  type="radio"
                  name="show_total"
                  v-model="form.show_total"
                  :value="true"
                  checked
                />
                <label class="form-check-label" for="show_total">
                  Totals Only
                </label>
              </div>

              <div class="form-check col-md-3">
                <input
                  class="form-check-input"
                  type="radio"
                  name="show_total"
                  v-model="form.show_total"
                  :value="false"
                />
                <label class="form-check-label" for="show_total">
                  All Records
                </label>
              </div>
            </div>
            <div class="mt-2">
              <div class="d-inline-flex" style="align-items: center;">
                <label for="sort_on" class="form-label m-0">Sort on:</label>

                <div class="ms-3">
                  <b-select
                    class="form-select form-select-sm ml-2"
                    aria-label="Default select example"
                    name="sort_on"
                    v-model="form.sort_on"
                  >
                    <option value="fullname">User Name</option>
                    <option value="date">Transaction Date</option>
                    <option value="type">Transaction Type</option>
                    <option value="bywhom">
                      Who Performed the Transaction
                    </option>
                    <option value="points">Point Value of Transaction</option>
                    <option value="productid">Product Ordered</option>
                    <option value="ordernumber">Order Number</option>
                  </b-select>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-3 border p-2">
            <label class="form-label">Subtotal Points By: </label>
            <div class="">
              <div class="d-flex">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value="client"
                    id="client"
                    v-model="form.sub_total_by"
                  />
                  <label class="form-check-label" for="client"> Client </label>
                </div>
              </div>

              <div class="d-flex">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value="bywhom"
                    id="bywhom"
                    v-model="form.sub_total_by"
                  />
                  <label class="form-check-label" for="bywhom">
                    Who performed the transaction
                  </label>
                </div>
              </div>

              <div class="d-flex">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value="code"
                    id="code"
                    v-model="form.sub_total_by"
                  />
                  <label class="form-check-label" for="code"> User Code </label>
                </div>
              </div>

              <div class="d-flex">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value="program"
                    id="program"
                    v-model="form.sub_total_by"
                  />
                  <label class="form-check-label" for="program">
                    Programs & Contests
                  </label>
                </div>
              </div>

              <div class="d-flex">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value="product"
                    id="product"
                    v-model="form.sub_total_by"
                  />
                  <label class="form-check-label" for="product">
                    By Products
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-3 border p-2">
            <label class="form-label">Create/Send CSV Report: </label>

            <div class="d-flex">
              <div class="form-check d-inline-flex col-md-1">
                <input
                  class="form-check-input"
                  type="radio"
                  name="export_to_excel"
                  :value="true"
                  v-model="form.export_to_excel"
                />
                <label class="form-check-label" for="export_to_excel">
                  Yes
                </label>
              </div>

              <div class="form-check d-inline-flex col-md-1">
                <input
                  class="form-check-input"
                  type="radio"
                  name="export_to_excel"
                  :value="false"
                  v-model="form.export_to_excel"
                  checked
                />
                <label class="form-check-label" for="export_to_excel">
                  No
                </label>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-8">
                <div class="mb-3">
                  <label for="email" class="form-label">Email:</label>
                  <input
                    type="text"
                    class="form-control"
                    name="email"
                    v-model="form.email"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-2 ms-4 ml-3">
        <input
          :disabled="disableCreateReportButton"
          type="submit"
          class="btn btn-primary"
          value="Create Report"
          @click.prevent="onSubmit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

const eDate = moment();
const sDate = moment().subtract(7, "d");
export default {
  name: "TransactionReportForm",
  data() {
    return {
      sDate: sDate,
      eDate: eDate,
      selectCompanyOptions: [],
      selectedClients: [],
      AllClientsProgram: [],
      disableCreateReportButton: false
    };
  },
  methods: {
    onSubmit() {
      if (this.eDate.diff(this.sDate, "months") > 6) {
        this.$store
          .dispatch("systemMessage/setModalMessage", {
            message: "Please select a date range of less than six months",
            subMessage: "Either change the start date or end date as needed",
          })
          .then(() => {
            this.$store.commit("systemMessage/SET_VISIBLE", true);
          });
        return;
      }
      if (this.form.transaction_types.length > 0) {
        this.form.is_all_transactions_selected = false;
      }
      if (this.form.export_to_excel && this.form.email == "") {
        alert("Please enter email address");
      } else if (this.form.export_to_excel && this.form.email !== "") {
        this.disableCreateReportButton = true
        this.$store
          .dispatch("transactionReport/addTransactionReportExcel", {
            form: this.form,
          })
          .then(() => {
            this.$store.commit("transactionReport/RESET_STATE");
            this.sDate = sDate;
            this.eDate = eDate;
          }).catch(e => {
            alert(`Something went wrong creating the report. Error: ${e}`)
          }).finally(() => {
            this.disableCreateReportButton = false
          });
      } else {
        this.$router
          .push({
            name: "AdminTransactionReportView",
          })
          .then(() => {
            window.scrollTo(0, 0);
          });
      }
    },
    clientSelected() {
      this.form.is_all_clients_selected = false;
    },
    allClients() {
      this.form.client_ids = [];
    },
    programSelected() {
      this.form.is_all_programs_selected = false;
    },
    allPrograms() {
      this.form.program_ids = [];
    },
    userCodeSelected() {
      this.form.is_all_user_code_selected = false;
    },
    allUserCode() {
      this.form.user_codes = [];
    },
    transactionSelected() {
      this.form.is_all_transactions_selected = false;
    },
    allTransactions() {
      this.form.transaction_types = [];
    },
  },
  computed: {
    form() {
      return this.$store.state.transactionReport.form;
    },
    authorizedClients() {
      return this.$store.getters["loginsAndOrdersReport/getAuthorizedClients"];
    },
    allClientsProgram() {
      const res = this.$store.getters[
        "adminBatchUserUploadTool/getAllClientsProgram"
      ];
      return res;
    },
    userCodes() {
      return this.$store.getters["transactionReport/getUserCodes"];
    },
    startDate() {
      var jsObj = JSON.parse(JSON.stringify(this.sDate.format("YYYY-MM-DD")));
      var dt = new Date(jsObj);
      var newDate = dt.toISOString();
      this.form.start_date = newDate;
    },
    endDate() {
      let newDate = this.eDate.format("YYYY-MM-DD") + "T23:59:59Z";
      this.form.end_date = newDate;
    },
    visible() {
      return this.$store.state.systemMessage.visible;
    },
  },
  watch: {
    allClientsProgram(allClientsProgram) {
      var datas = allClientsProgram.map(function(data) {
        return {
          client_id: data.clientId,
          client_name: data.clientName,
          authorized_clients_programs: data.authorizedClientsPrograms.map(
            function(program) {
              return {
                program_id: program.programId,
                program_name: program.programName,
              };
            }
          ),
        };
      });
      console.log(datas, "from watcher");
      this.AllClientsProgram = datas;
      console.log(this.AllClientsProgram);
    },
    visible(newVal, oldVal) {
      if (newVal === false && oldVal === true) {
        window.scrollTo(0, 0);
      }
    },
  },
  mounted() {
    console.log(this.form);
    this.$store.dispatch("loginsAndOrdersReport/fetchAuthorizedClients");
    this.$store
      .dispatch("adminBatchUserUploadTool/fetchAllClientsProgram", {
        clientId: 0,
        status: "all",
      })
      .then((res) => {
        console.log(res, "Response from fetchAllClientsProgram");
      });
    this.$store.dispatch("transactionReport/fetchUserCodes");

    // load clear state
    this.$store.state.transactionReport.form = {
      start_date: sDate.format("YYYY-MM-DD") + "T00:00:00Z",
      end_date: eDate.format("YYYY-MM-DD") + "T23:59:59Z",
      is_all_clients_selected: true,
      client_ids: [],
      is_all_programs_selected: true,
      program_ids: [],
      is_all_user_code_selected: true,
      user_codes: [],
      is_all_transactions_selected: true,
      show_my_transaction: false,
      transaction_types: [],
      show_total: true,
      sort_on: "fullname",
      sub_total_by: [],
      export_to_excel: false,
      email: "",
    };
  },
};
</script>

<style scoped>
.border {
  border-radius: 5px;
}

.page-heading {
  font-size: 20px;
  font-weight: 500;
}
</style>
<style lang="scss"></style>
